
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import './App.css';
import LoginComponent from './Component/Login/LoginComponent';
import ProductComponent from './Component/Product/ProductComponent';
import DistributorComponent from './Component/Distributor/DistributorComponent';
import Dashboard from './Component/Dashboard/Dashboard';
import Profile from './Component/Profile/Profile';
import Setting from './Component/Settings/Setting';
import MainLayout from "./Component/Mainlayout/Mainlayout";
import { useState } from "react";
import Resellers from "./Component/Resellers/Resellers";
import Clients from "./Component/Clients/Clients";
import Order from "./Component/Order/Order";
import Investment from './Component/Investment/Investment';
import AmountTrasfer from './Component/AmountTransfer/AmountTransfer';
import Linkform from "./Component/LinkForm/Linkform"
import Editform from "./Component/Editform/Editform";
import DisturbutorLinkForm from "./Component/DisturbutorLinkForm/DisturbutorLinkForm";
import DisturbutorEditForm from "./Component/DisturbutorEditForm/DisturbutorEditForm";
import PriceList from "./Component/PriceList/PriceList";
import AssignPriceList from "./Component/PriceList/AssignPriceList";
import AssignReseller from "./Component/PriceList/AssignReseller";
import CreateMultiPriceList from "./Component/PriceList/CreateMultiPriceList";
import DistributerProduct from "./Component/PriceList/DistributerProduct";
import ViewPricelistHistory from "./Component/PriceList/ViewPricelistHistory";
import ProviderAssignProduct from "./Component/Product/ProviderAssignProduct";
import ClientProductList from "./Component/PriceList/ClientProductList";
import AddClientProdectPrice from "./Component/PriceList/AddClientProdectPrice";
import FogotPassword from "./Component/Login/FogotPassword";
import PasswordReset from "./Component/Login/PasswordReset";



function App() {
  const providerId = sessionStorage.getItem('providerId');
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  // Authentication state

  const protectedRoutes = [
    { path: "/dashboard", component: <Dashboard /> },
    { path: "/profile", component: <Profile /> },
    { path: "/settings", component: <Setting /> },
    // {
    //   path: "/product",
    //   component: providerId !== "0" ? (
    //     <ProviderAssignProduct />
    //   ) : (
    //     <ProductComponent />
    //   ),
    // },
    {
      path: "/product",
      component: <ProductComponent />
    },
    { path: "/reseller", component: <Resellers /> },
    { path: "/client", component: <Clients /> },
    { path: "/distributer", component: <DistributorComponent /> },
    { path: "/investment", component: <Investment /> },
    { path: "/amountransfer", component: <AmountTrasfer /> },
    // { path:"/order/:did", component:<Order />}
    { path: "/order/:did/:cid", component: <Order /> },
    { path: "/pricelist/:did/:cid", component: <PriceList /> },
    { path: "/assignreseller", component: <AssignReseller /> },
    { path: "/assignpricelist/:did", component: <AssignPriceList /> },
    { path: "/createpricelist/:did", component: <CreateMultiPriceList /> },
    { path: "/distributerproduct/:did", component: <DistributerProduct /> },
    { path: "/clientproductlist/:cid", component: <ClientProductList /> },
    { path: "/selltoclient/:cid", component: <AddClientProdectPrice /> },
    { path: "/viewpricelist/:dpid", component: <ViewPricelistHistory /> }

  ];
  return (
    <div className="App">
      <Routes>
        <Route
          path="/login"
          element={isLoggedIn ? <LoginComponent /> : <Navigate to="/dashboard" />}
        />
        <Route path="/" element={<Navigate to="/login" />} />

        <Route path="/" element={<LoginComponent />} />
        <Route
          element={

            <MainLayout />

          }
        >
          {protectedRoutes.map(({ path, component }) => (
            <Route key={path} path={path} element={component} />
          ))}
        </Route>
        <Route path="/share/:disid/:typeid/:nanoid" element={<Linkform />} />
        <Route path="/editform" element={<Editform />} />
        <Route path="/sharedisturbutor/:disturbid/:typeid/:nanoid" element={<DisturbutorLinkForm />} />
        <Route path="/editdisturbutor" element={<DisturbutorEditForm />} />
        <Route path="/forgot-password" element={<FogotPassword />} />
        <Route path="/reset-password/:token" element={<PasswordReset />} />
        





      </Routes>
    </div>
  );
}

export default App;
